import React from 'react'

import { Button, DiscountGradient } from '@cgtrader/triangle-ui/dist/src/ssr-index'

import i18n from 'Pods/Shared/I18n'

function PromoPanel() {
  const translate = (key) => i18n.t(`listingPage.upsellBlock.${key}`, { ns: 'rails' })

  return (
    <div className="upsell-block__promo-inner">
      <div className="upsell-block__promo-label">
        <DiscountGradient className="upsell-block__promo-label-icon" />
        <span className="upsell-block__promo-label-text">{translate('label')}</span>
      </div>
      <div className="upsell-block__promo-text">
        <h3 className="upsell-block__promo-heading cgt-heading-300">
          {translate('heading')}
        </h3>
        <p className="upsell-block__promo-body cgt-body-base">
          {translate('bodyPrefix')}
          {' '}
          <strong className="cgt-body-lg-semibold">{translate('bodyPrice')}</strong>
          {translate('bodySuffix')}
        </p>
      </div>
      <Button
        href="/subscription"
        type="primary"
        size="small"
        customClass="upsell-block__promo-cta"
      >
        {translate('cta')}
      </Button>
    </div>
  )
}

export default PromoPanel
